export default {
    UPDATE_USER_PROFILE: "UPDATE_USER_PROFILE",
    UPDATE_USER_PROFILE_SUCCESS: "UPDATE_USER_PROFILE_SUCCESS",
    UPDATE_USER_PROFILE_ERROR: "UPDATE_USER_PROFILE_ERROR",

    DELETE_USER_PROFILE: "DELETE_USER_PROFILE",
    DELETE_USER_PROFILE_SUCCESS: "DELETE_USER_PROFILE_SUCCESS",
    DELETE_USER_PROFILE_ERROR: "DELETE_USER_PROFILE_ERROR",
};